export default __webpack_public_path__ + "static/media/ProfileMobile.3f5a01a2.png";